import "./Policy.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  PolicyDiv,
  PolicyTxt,
  PrivacyDiv,
  PrivacyTxt,
  RefundDiv,
} from "../../utils/policyUtils";
import useAndroidBridge from "../../hooks/useAndroidBridge";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";

const Policy = () => {
  const loaction = useLocation();

  console.log(loaction);

  // For mobile =================================================================================
  const [searchParams] = useSearchParams();
  const { isEmbed } = useMembership();
  const { sendToAndroid } = useAndroidBridge();
  const callBackPath = searchParams.get("callBackPath") || "";
  const navigate = useNavigate();
  /* for mobile ================================================================================= */

  return (
    <>
      {isEmbed() && (
        <div className={`mobile_app_header`}>
          <button
            onClick={
              () => navigate(-1)
              // sendToAndroid("go-to-page", "terms")
            }
            className={`btn btn_back`}
          ></button>
          <p className={`mobile_app_header_text`}>
            {loaction?.pathname === `/policy` && `서비스 이용 약관`}
            {loaction?.pathname === `/privacy` && `개인 정보 처리방침`}
            {loaction?.pathname === `/refund` && `개인 환불 정책`}
          </p>
        </div>
      )}
      <div className={`content_wrap policy`}>
        <div className={`section_wrap`}>
          <div className={`sec`}>
            <div className={`info_group`}>
              {loaction?.pathname === `/policy` && (
                <>
                  <h3 className={`tit`}>서비스 이용 약관</h3>
                  <div className={`txt`}>
                    <PolicyDiv />
                  </div>
                </>
              )}
              {loaction?.pathname === `/privacy` && (
                <>
                  <h3 className={`tit`}>개인 정보 처리방침</h3>
                  <div className={`txt`}>
                    <PrivacyDiv />
                  </div>
                </>
              )}
              {loaction?.pathname === `/refund` && (
                <>
                  <h3 className={`tit`}>개인 환불 정책</h3>
                  <div className={`txt`}>
                    <RefundDiv />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Policy;
